import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getAllUserLinks } from "../../../services/getAllUserLinks";
import { QueryKeys } from "../../../services/types";
import styled from "styled-components";
import StatusInfo, { StatusInfoVariant } from "../../atoms/StatusInfo";
import SingleLink from "../../atoms/SingleLink";

type MyLinksSectionProps = {
  tagList:
    | {
        created_at: string;
        id: number;
        name: string | null;
        links_count?: number;
      }[]
    | null
    | undefined;
};

const MyLinksSection = ({ tagList }: MyLinksSectionProps) => {
  const {
    data: response,
    isLoading,
  } = useQuery({
    queryFn: getAllUserLinks,
    queryKey: [QueryKeys.USER_LINKS],
    refetchOnMount: false,
  });

  return (
    <StyledMyLinksSection>
      {response?.data?.map((link, index) => {
        const matchingTag = tagList?.find((tag) => tag.id === link.tag_id);
        return (
          <SingleLink
            key={`${link.title}_${index}`}
            link={link}
            tagName={matchingTag?.name}
            tagLinksCount={Number(matchingTag?.links_count)}
            pageType="profile"
          />
        );
      })}

      {isLoading && (
        <StatusInfo variant={StatusInfoVariant.LOADING} text="Loading" />
      )}
      {response?.error?.message && (
        <StatusInfo
          variant={StatusInfoVariant.ERROR}
          text={`${response.status}: ${response.error.message}`}
        />
      )}
    </StyledMyLinksSection>
  );
};

const StyledMyLinksSection = styled.div`
  display: flex;
  flex-flow: wrap row;
  justify-content: center;
  align-items: flex-start;
  gap: 30px 20px;
  width: 100%;
  margin-bottom: 10px;
`;

export default MyLinksSection;
